import { signIn, signInKaseyaOne } from '@app/store/actions';

import {
    ICredentials,
    HandleSignin,
    SetCredentials,
    SetLoginForm,
    HandleKaseyaOneSignin
} from '@app/models';
import { loginForms } from '@app/enums';

export const handleSignin =
    ({ username, password, rememberMe, setIsError, setErrorCode, dispatch, setEmptyUsernameError, setEmptyPasswordError }: HandleSignin) =>
    (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (username && password) {
            setIsError(false);
            setErrorCode('');
            dispatch<any>(signIn(username, password, '', rememberMe));
        }

        setEmptyUsernameError && setEmptyUsernameError(!username);
        setEmptyPasswordError(!password);
    };

export const handleKaseyaOneSignin = ({ username, password, setErrorKaseyaOneCode, setIsPageLoading, setLoginForm, setIsLoading, dispatch }: HandleKaseyaOneSignin) => {
    setErrorKaseyaOneCode('');
    dispatch<any>(signInKaseyaOne( setErrorKaseyaOneCode, setIsPageLoading, setIsLoading, setLoginForm, username, password));
};

export const handleForgetPassword = (setLoginForm: SetLoginForm) => (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();

    setLoginForm(loginForms.resetPasswordValidate);
};

export const handleChangeUsername =
    (setCredentials: SetCredentials) =>
    (e: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = e.target;
        setCredentials((state: ICredentials) => ({ ...state, username: value }));
    };

export const handleChangePassword =
    (setCredentials: SetCredentials) =>
    (e: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = e.target;
        setCredentials((state: ICredentials) => ({ ...state, password: value }));
    };
